
// import { Suspense, lazy } from "react";
// import "./Home.css";

// // import jmk2025 from '../../assets/images/JMK Re 25.jpg';

// // import jmkReport from '../../assets/images/jmk.jpeg';
// // import crisilBridge from '../../assets/images/crisilBridge.webp';
// // import gautamSolarRank from '../../assets/images/gautamSolarRank.webp';
// // import New2 from "../../assets/images/new2.jpg"

// import FAQ from "../../component/faq/FAQ";
// import { Helmet } from "react-helmet";
// import WhyChooseGautamSolar from "../../component/solarpanel/SolarPanel";
// import AmongTopSolar from "../../component/amongtopsolar/AmongTopSolar";
// import Kiwi from "../../component/Kiwi";
// import Slider from "../../component/Slider/Slider";

// // Lazy-loaded components
// const VideoSecond = lazy(() => import("../../component/videosecond/VideoSecond"));

// const SolarMod = lazy(() => import("../../component/solarmod/SolarMod"));
// const Factories = lazy(() => import("../../component/factories/Factories"));
// const SliderFirst = lazy(() => import("../../component/sliderfirst/SliderFirst"));
// const ContactBox = lazy(() => import("../../component/enquiry/ContactBox"));



// function Home() {

//   const topSolar = [
//     { title: ' JMK Research & Analytics', desc: 'RE Update FY 2025', img: '/TOP_10_JMK.webp', alt: 'Top 10 Solar ' },
//     // { title: ' JMK Research & Analytics', desc: ' RE Update Q3 2025.', img: '/Top_8.webp', alt: 'Top 10 solar module' },
//     { title: ' JMK Research & Analytics', desc: 'Among India Top 10 Solar Module Manufacturers', img: '/top10.jpeg', alt: 'Top 10 solar module' },
//     // { title: ' JMK Research & Analytics', desc: ' RE Update Q4 2025.', img: '/JKM_Ranked.jpeg', alt: 'Top 10 solar module' },
//     { title: ' CRISIL Bridge To India', desc: 'India PV Module Intelligence Brief | Q4 2024', img: '/Crisil.webp', alt: 'Top 10 solar ' },
//     // { title: ' JMK 2024', desc: 'RE Update Q4 2024', img: '/JMK_Q4.webp', alt: 'Top 10 Solar ' },
//   ]


//   // const topSolar2 = [
//   //   { img: '/Grade_A.webp' },
//   //   { img: '/Global_Top_30.webp' },
//   // ]

//   const heading = "AMONG INDIA'S";
//   const subHeading = "TOP 10 SOLAR MODULE MANUFACTURERS"

//   return (
//     <>
//       <Helmet>
//         <title>Top 10 Solar Module Manufacturers company in india</title>
//         <meta
//           name="description"
//           content="Searching for the Best Top 10 Solar Module Manufacturers company in India? Gautam Solar is among the most reliable solar companies, boasting over 25 years of experience. The company specialises in producing high-efficiency solar modules, including Mono PERC and state-of-the-art N-Type TOPCon panels. "
//         />
//         <meta
//           name="keywords"
//           content="Top Solar Module Plant, Top 10 Solar Module Manufacturers company in india, India Solar Manufacturer company, Solar panels, solar manufacturing company in india"
//         />
//       </Helmet>
//       <h1 className="sr-only">AMONG INDIA'S TOP 10 SOLAR MODULE MANUFACTURERS</h1>

//       <Slider />

//       <Suspense
//         fallback={
//           <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
//             <div className="spinner-border" role="status" style={{ color: '#a20000' }}>
//               <span className="visually-hidden">Loading...</span>
//             </div>
//           </div>
//         }
//       >
//         <VideoSecond />
//         <AmongTopSolar
//           heading={heading}
//           subHeading={subHeading}
//           topSolar={topSolar} />
//         <SolarMod />
//         <Kiwi />
//         <WhyChooseGautamSolar />
//         <Factories />

//         <SliderFirst />
//         <FAQ />
//         <ContactBox />
//       </Suspense>
//     </>
//   );
// }

// export default Home;



import { Suspense, lazy, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

import "./Home.css";
import FAQ from "../../component/faq/FAQ";
import { Helmet } from "react-helmet";
import WhyChooseGautamSolar from "../../component/solarpanel/SolarPanel";
import AmongTopSolar from "../../component/amongtopsolar/AmongTopSolar";
import Kiwi from "../../component/Kiwi";
import Slider from "../../component/Slider/Slider";
import { Container } from "react-bootstrap";
import bessBanner from '../../assets/images/BESS_Banner.webp'
import G12RSolarCellPage from "../Cell/Cell";
import CellIntroSection from "../Cell/Intro";

// Lazy-loaded components
const VideoSecond = lazy(() => import("../../component/videosecond/VideoSecond"));

const SolarMod = lazy(() => import("../../component/solarmod/SolarMod"));
const Factories = lazy(() => import("../../component/factories/Factories"));
const SliderFirst = lazy(() => import("../../component/sliderfirst/SliderFirst"));
const ContactBox = lazy(() => import("../../component/enquiry/ContactBox"));




function Home() {

  const topSolar = [
    { title: ' JMK Research & Analytics', desc: 'RE Update FY 2026', img: '/top-4.jpeg', alt: 'Top 4 Solar ' },

    { title: ' JMK Research & Analytics', desc: 'RE Update FY 2025', img: '/TOP_10_JMK.webp', alt: 'Top 10 Solar ' },
    // { title: ' JMK Research & Analytics', desc: ' RE Update Q3 2025.', img: '/Top_8.webp', alt: 'Top 10 solar module' },
    { title: ' JMK Research & Analytics', desc: 'Among India Top 10 Solar Manufacturers', img: '/top10.webp', alt: 'Top 10 solar Manufacturers' },
    // { title: ' JMK Research & Analytics', desc: ' RE Update Q4 2025.', img: '/JKM_Ranked.jpeg', alt: 'Top 10 solar module' },
    { title: ' CRISIL Bridge To India', desc: 'India PV Module Intelligence Brief | Q4 2024', img: '/Crisil.webp', alt: 'Top 10 solar ' },
    // { title: ' JMK 2024', desc: 'RE Update Q4 2024', img: '/JMK_Q4.webp', alt: 'Top 10 Solar ' },
  ]


  // const topSolar2 = [
  //   { img: '/Grade_A.webp' },
  //   { img: '/Global_Top_30.webp' },
  // ]

  const heading = "AMONG INDIA'S";
  const subHeading = "TOP 4 SOLAR MANUFACTURERS"

  return (
    <>
      <Helmet>
        <title>Top 10 Solar Manufacturers company in india</title>
        <meta
          name="description"
          content="Searching for the Best Top 10 Solar Module Manufacturers company in India? Gautam Solar is among the most reliable solar companies, boasting over 25 years of experience. The company specialises in producing high-efficiency solar modules, including Mono PERC and state-of-the-art N-Type TOPCon panels. "
        />
        <meta
          name="keywords"
          content="Top Solar Module Plant, Top 10 Solar Module Manufacturers company in india, India Solar Manufacturer company, Solar panels, solar manufacturing company in india"
        />

        <link rel="canonical" href="https://gautamsolar.com/" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Gautam Solar",
            url: "https://gautamsolar.com/",
            logo: "https://gautamsolar.com/Round Corner Logo0 (1).png",
            description:
              "Gautam Solar is a leading ALMM-listed solar panel manufacturer in India with over 25 years of experience, specializing in Mono PERC and N-Type TOPCon solar modules.",
            address: {
              "@type": "PostalAddress",
              streetAddress: "D-120-121, Okhla Industrial Area, Phase-1",
              addressLocality: "New Delhi",
              postalCode: "110020",
              addressCountry: "IN",
            },
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+91-93117-97248",
              contactType: "customer service",
              email: "info@gautamsolar.com",
            },
            sameAs: [
              "https://www.facebook.com/gautamsolarprivatelimited",
              "https://www.instagram.com/gautam_solar/",
              "https://www.linkedin.com/company/gautam-solar-group/",
              "https://www.youtube.com/@GautamSolarOfficial",
            ],
          })}

        </script>
      </Helmet>
      <h1 className="sr-only">AMONG INDIA'S TOP 4 SOLAR MODULE MANUFACTURERS</h1>

      <Slider />

      <Suspense
        fallback={
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
            <div className="spinner-border" role="status" style={{ color: '#a20000' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        }
      >
        <VideoSecond />
        <AmongTopSolar
          heading={heading}
          subHeading={subHeading}
          topSolar={topSolar} />
        <CellIntroSection/>
        <SolarMod />
        <CombinedInverterBessSection />
        {/* <GautamSolarG12R/> */}
        {/* <G12RSolarCellPage/> */}
        <Kiwi />
        <WhyChooseGautamSolar />
        {/* <BessSection /> */}
        <Factories />

        <SliderFirst />
        <FAQ />
        <ContactBox />
      </Suspense>
    </>
  );
}

export default Home;



// const CombinedInverterBessSection = () => {
//   const navigate = useNavigate();
//   const theme = '#a20000'; // Exact 6-digit hex code
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const checkScreen = () => setIsMobile(window.innerWidth <= 768);
//     checkScreen();
//     window.addEventListener('resize', checkScreen);
//     return () => window.removeEventListener('resize', checkScreen);
//   }, []);

//   // --- Main Section ---
//   const sectionStyle = {
//     padding: isMobile ? '60px 16px' : '100px 24px',
//     backgroundColor: '#fafafa',
//     fontFamily: '"Inter", "Segoe UI", Roboto, Arial, sans-serif',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center'
//   };

//   // --- Centered Header ---
//   const headerWrapperStyle = {
//     textAlign: 'center',
//     marginBottom: '48px',
//     maxWidth: '800px'
//   };

//   const mainHeadingStyle = {
//     fontSize: isMobile ? '32px' : '46px',
//     fontWeight: '800',
//     color: '#1a1a1a',
//     margin: '0 0 16px 0',
//     letterSpacing: '-0.02em',
//     textTransform: 'uppercase'
//   };

//   const subTitleStyle = {
//     fontSize: isMobile ? '15px' : '17px',
//     color: '#666',
//     lineHeight: '1.6',
//     margin: 0
//   };

//   // --- White Card Container ---
//   const cardContainerStyle = {
//     width: '100%',
//     maxWidth: '1000px',
//     backgroundColor: '#ffffff',
//     borderRadius: '16px',
//     border: '1px solid #eaeaea',
//     boxShadow: '0 8px 30px rgba(0, 0, 0, 0.04)',
//     padding: isMobile ? '32px 20px' : '56px 48px',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center'
//   };

//   // --- Badge Style ---
//   const badgeStyle = {
//     backgroundColor: theme,
//     color: '#ffffff',
//     padding: '8px 20px',
//     borderRadius: '100px',
//     fontSize: '12px',
//     fontWeight: '700',
//     letterSpacing: '1px',
//     textTransform: 'uppercase',
//     marginBottom: '48px',
//     display: 'inline-block'
//   };

//   // --- Product Block Styles (Stacked) ---
//   const productBlockStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     textAlign: 'center',
//     width: '100%'
//   };

//   const productTitleStyle = {
//     fontSize: isMobile ? '24px' : '28px',
//     fontWeight: '700',
//     color: '#1a1a1a',
//     marginBottom: '24px',
//     marginTop: 0
//   };

//   const upcomingTagStyle = {
//     backgroundColor: 'rgba(162, 0, 0, 0.08)',
//     color: theme,
//     padding: '6px 14px',
//     borderRadius: '100px',
//     fontSize: '12px',
//     fontWeight: '700',
//     textTransform: 'uppercase',
//     letterSpacing: '0.5px',
//     marginBottom: '12px',
//     display: 'inline-block'
//   };

//   const imageWrapperStyle = {
//     width: '100%',
//     maxWidth: '600px',
//     aspectRatio: '16/9',
//     backgroundColor: '#f8f9fa',
//     borderRadius: '12px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     border: '1px solid #f0f0f0',
//     marginBottom: '32px'
//   };

//   // --- Specs Grid (2 columns inside the stacked block for better space usage) ---
//   const specsGridStyle = {
//     display: 'grid',
//     gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//     gap: '16px 32px',
//     width: '100%',
//     maxWidth: '800px',
//     textAlign: 'left',
//     marginBottom: '40px'
//   };

//   const specItemStyle = {
//     display: 'flex',
//     alignItems: 'flex-start',
//     gap: '12px',
//     fontSize: '15px',
//     lineHeight: '1.6',
//     color: '#444'
//   };

//   const bulletStyle = {
//     color: theme,
//     fontWeight: '700',
//     fontSize: '18px',
//     lineHeight: '1.4'
//   };

//   const buttonStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     gap: '10px',
//     padding: '16px 40px',
//     backgroundColor: theme,
//     color: '#ffffff',
//     border: 'none',
//     borderRadius: '8px',
//     fontSize: '16px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//     boxShadow: '0 4px 14px rgba(162, 0, 0, 0.2)',
//     width: isMobile ? '100%' : 'auto'
//   };

//   const dividerStyle = {
//     width: '100%',
//     height: '1px',
//     backgroundColor: '#eaeaea',
//     margin: '64px 0'
//   };

//   const handleInverterClick = () => navigate('/inverter');
//   const handleBessClick = () => navigate('/bess');

//   const handleHover = (e, isHovering) => {
//     if (isMobile) return;
//     if (isHovering) {
//       e.currentTarget.style.transform = 'translateY(-2px)';
//       e.currentTarget.style.boxShadow = '0 8px 24px rgba(162, 0, 0, 0.35)';
//     } else {
//       e.currentTarget.style.transform = 'translateY(0)';
//       e.currentTarget.style.boxShadow = '0 4px 14px rgba(162, 0, 0, 0.2)';
//     }
//   };

//   return (
//     <section style={sectionStyle}>

//       {/* Centered Heading Section */}
//       <div style={headerWrapperStyle}>
//         <h2 style={mainHeadingStyle}>
//           INVERTER & <span style={{ color: theme }}>BESS</span>
//         </h2>
//         <p style={subTitleStyle}>
//           Explore our comprehensive range of reliable solar inverters and advanced battery energy storage systems.
//         </p>
//       </div>

//       {/* White Card Container */}
//       <div style={cardContainerStyle}>

//         <span style={badgeStyle}>PRODUCT OVERVIEW</span>

//         {/* ================= INVERTER BLOCK (TOP) ================= */}
//         <div style={productBlockStyle}>
//           <h3 style={productTitleStyle}>Solar Inverters</h3>

//           <div style={imageWrapperStyle}>
//             {/* REPLACE THIS SVG WITH YOUR ACTUAL IMAGE */}
//             <img
//             src="inverterSection.webp"
//             alt="Gautam Solar Inverter"
//             style={{ width: '100%', height: '100%', objectFit: 'contain' }}
//           />
//           </div>

//           <div style={specsGridStyle}>
//             <div style={specItemStyle}>
//               <span style={bulletStyle}>→</span>
//               <span>Available in 3 kW and 5 kW models with MPPT technology.</span>
//             </div>
//             <div style={specItemStyle}>
//               <span style={bulletStyle}>→</span>
//               <span>Maximum efficiency of up to 97.5% and MPPT efficiency above 99%.</span>
//             </div>
//             <div style={specItemStyle}>
//               <span style={bulletStyle}>→</span>
//               <span>Wi-Fi and RS485 communication for compatible monitoring systems.</span>
//             </div>
//             <div style={specItemStyle}>
//               <span style={bulletStyle}>→</span>
//               <span>IP65 enclosure protection against dust and water ingress.</span>
//             </div>
//           </div>

//           <button
//             style={buttonStyle}
//             onClick={handleInverterClick}
//             onMouseEnter={(e) => handleHover(e, true)}
//             onMouseLeave={(e) => handleHover(e, false)}
//           >
//             Explore Inverters
//             <span style={{ fontSize: '18px', lineHeight: 1 }}>→</span>
//           </button>
//         </div>

//         {/* Divider Line */}
//         <div style={dividerStyle}></div>

//         {/* ================= BESS BLOCK (BOTTOM) ================= */}
//         <div style={productBlockStyle}>
//           {/* Small Tag above BESS Title */}
//           <span style={upcomingTagStyle}>Upcoming in 2027</span>

//           <h3 style={productTitleStyle}>Battery Energy Storage Systems</h3>

//           <div style={imageWrapperStyle}>
//             {/* REPLACE THIS SVG WITH YOUR ACTUAL IMAGE */}
//             <img
//             src="bessSection-1.webp"
//             alt="Gautam Solar BESS"
//             style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//           />
//           </div>

//           <div style={specsGridStyle}>
//             <div style={specItemStyle}>
//               <span style={bulletStyle}>→</span>
//               <span>Modular architecture designed to scale with changing project requirements.</span>
//             </div>
//             <div style={specItemStyle}>
//               <span style={bulletStyle}>→</span>
//               <span>Advanced LFP chemistry with multi-layer protection and real-time monitoring.</span>
//             </div>
//             <div style={specItemStyle}>
//               <span style={bulletStyle}>→</span>
//               <span>C&I solution: 125 kW / 261.2 kWh capacity, 90% DoD, IP55 rating.</span>
//             </div>
//             <div style={specItemStyle}>
//               <span style={bulletStyle}>→</span>
//               <span>Utility-scale solution: GS-5000-LC model, 5,015 kWh capacity, 8,000 cycles.</span>
//             </div>
//           </div>

//           <button
//             style={buttonStyle}
//             onClick={handleBessClick}
//             onMouseEnter={(e) => handleHover(e, true)}
//             onMouseLeave={(e) => handleHover(e, false)}
//           >
//             Explore BESS
//             <span style={{ fontSize: '18px', lineHeight: 1 }}>→</span>
//           </button>
//         </div>

//       </div>
//     </section>
//   );
// };


// -------------------------



const GautamSolarG12R = () => {
  const styles = {
    page: {
      fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif",
      color: "#1a1a1a",
      background: "#ffffff",
      lineHeight: 1.6,
    },
    hero: {
      background: "linear-gradient(135deg, #0b3d2e 0%, #1a7a4c 50%, #f5a623 100%)",
      color: "#fff",
      padding: "80px 24px",
      textAlign: "center",
    },
    heroBadge: {
      display: "inline-block",
      background: "rgba(255,255,255,0.15)",
      border: "1px solid rgba(255,255,255,0.3)",
      padding: "6px 16px",
      borderRadius: "999px",
      fontSize: "13px",
      letterSpacing: "1px",
      textTransform: "uppercase",
      marginBottom: "20px",
    },
    heroTitle: {
      fontSize: "clamp(28px, 5vw, 52px)",
      fontWeight: 800,
      margin: "0 0 16px",
      lineHeight: 1.15,
    },
    heroSubtitle: {
      fontSize: "clamp(15px, 2vw, 19px)",
      maxWidth: "820px",
      margin: "0 auto",
      opacity: 0.95,
    },
    section: {
      padding: "64px 24px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    sectionAlt: {
      background: "#f6f9f7",
      padding: "64px 24px",
    },
    sectionAltInner: {
      maxWidth: "1200px",
      margin: "0 auto",
    },
    sectionTitle: {
      fontSize: "clamp(22px, 3vw, 32px)",
      fontWeight: 700,
      color: "#0b3d2e",
      marginBottom: "12px",
    },
    sectionTitleUnderline: {
      width: "60px",
      height: "4px",
      background: "#f5a623",
      borderRadius: "2px",
      marginBottom: "28px",
    },
    paragraph: {
      fontSize: "16px",
      color: "#3a3a3a",
      marginBottom: "16px",
    },
    featuresGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
      gap: "20px",
      marginTop: "24px",
    },
    featureCard: {
      background: "#fff",
      border: "1px solid #e3ece7",
      borderLeft: "4px solid #1a7a4c",
      borderRadius: "10px",
      padding: "20px 22px",
      boxShadow: "0 2px 10px rgba(11,61,46,0.05)",
    },
    featureTitle: {
      fontSize: "16px",
      fontWeight: 700,
      color: "#0b3d2e",
      marginBottom: "8px",
    },
    featureText: {
      fontSize: "14.5px",
      color: "#4a4a4a",
      margin: 0,
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "20px",
      background: "#fff",
      borderRadius: "10px",
      overflow: "hidden",
      boxShadow: "0 2px 14px rgba(11,61,46,0.06)",
      fontSize: "15px",
    },
    th: {
      textAlign: "left",
      padding: "14px 18px",
      background: "#0b3d2e",
      color: "#fff",
      fontWeight: 600,
      fontSize: "14px",
      letterSpacing: "0.3px",
    },
    td: {
      padding: "13px 18px",
      borderBottom: "1px solid #eef3f0",
      color: "#3a3a3a",
    },
    tdAlt: {
      padding: "13px 18px",
      borderBottom: "1px solid #eef3f0",
      color: "#3a3a3a",
      background: "#fafcfb",
    },
    whyGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "22px",
      marginTop: "24px",
    },
    whyCard: {
      background: "#fff",
      borderRadius: "12px",
      padding: "26px 24px",
      border: "1px solid #e3ece7",
      boxShadow: "0 4px 16px rgba(11,61,46,0.05)",
    },
    whyIcon: {
      width: "42px",
      height: "42px",
      borderRadius: "10px",
      background: "linear-gradient(135deg, #1a7a4c, #f5a623)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      fontSize: "20px",
      marginBottom: "14px",
    },
    whyTitle: {
      fontSize: "17px",
      fontWeight: 700,
      color: "#0b3d2e",
      marginBottom: "8px",
    },
    whyText: {
      fontSize: "14.5px",
      color: "#4a4a4a",
      margin: 0,
    },
    appGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "18px",
      marginTop: "24px",
    },
    appCard: {
      background: "#fff",
      borderRadius: "12px",
      padding: "24px 20px",
      textAlign: "center",
      border: "1px solid #e3ece7",
      boxShadow: "0 4px 16px rgba(11,61,46,0.05)",
    },
    appEmoji: {
      fontSize: "30px",
      marginBottom: "10px",
    },
    appTitle: {
      fontSize: "15.5px",
      fontWeight: 700,
      color: "#0b3d2e",
      marginBottom: "6px",
    },
    appText: {
      fontSize: "13.5px",
      color: "#5a5a5a",
      margin: 0,
    },
    timeline: {
      position: "relative",
      marginTop: "28px",
      paddingLeft: "28px",
      borderLeft: "3px solid #1a7a4c",
    },
    timelineItem: {
      marginBottom: "26px",
      position: "relative",
    },
    timelineDot: {
      position: "absolute",
      left: "-37px",
      top: "4px",
      width: "16px",
      height: "16px",
      borderRadius: "50%",
      background: "#f5a623",
      border: "3px solid #fff",
      boxShadow: "0 0 0 2px #1a7a4c",
    },
    timelineYear: {
      fontSize: "14px",
      fontWeight: 700,
      color: "#1a7a4c",
      marginBottom: "4px",
      textTransform: "uppercase",
      letterSpacing: "0.6px",
    },
    timelineText: {
      fontSize: "15px",
      color: "#3a3a3a",
      margin: 0,
    },
    cta: {
      background: "linear-gradient(135deg, #0b3d2e 0%, #1a7a4c 100%)",
      color: "#fff",
      padding: "64px 24px",
      textAlign: "center",
    },
    ctaTitle: {
      fontSize: "clamp(22px, 3vw, 30px)",
      fontWeight: 700,
      marginBottom: "14px",
    },
    ctaText: {
      fontSize: "16px",
      maxWidth: "720px",
      margin: "0 auto 28px",
      opacity: 0.92,
    },
    ctaButton: {
      display: "inline-block",
      background: "#f5a623",
      color: "#0b3d2e",
      fontWeight: 700,
      fontSize: "15px",
      padding: "14px 32px",
      borderRadius: "8px",
      textDecoration: "none",
      border: "none",
      cursor: "pointer",
      boxShadow: "0 6px 20px rgba(245,166,35,0.35)",
    },
    footnote: {
      textAlign: "center",
      fontSize: "13px",
      color: "#7a7a7a",
      fontStyle: "italic",
      padding: "30px 24px 40px",
      maxWidth: "900px",
      margin: "0 auto",
    },
  };

  const cellSpecs = [
    { label: "Technology", value: "N-Type TOPCon (Bifacial)" },
    { label: "Wafer Format", value: "G12R Rectangular" },
    { label: "Dimensions", value: "210 mm × 182.3 mm (± 0.25 mm)" },
    { label: "Diagonal", value: "Approx. 272 mm" },
    { label: "Thickness", value: "~130 μm (typical)" },
    { label: "Busbars", value: "16 (standard)" },
    { label: "Average Cell Efficiency", value: "~25.4–25.6%" },
    { label: "Average Wattage", value: "~9.7–9.8 W per cell" },
  ];

  const moduleSpecs = [
    { label: "Power Range", value: "620–640 Wp" },
    { label: "Peak Efficiency", value: "23.69%" },
    { label: "Number of Cells", value: "132 (half-cut)" },
    { label: "Bifacial Gain", value: "Up to 30%" },
    { label: "Power Gain vs. Standard TOPCon", value: "~5% higher" },
    { label: "Warranty", value: "12-year product, 30-year performance" },
  ];

  const features = [
    {
      title: "Rectangular Wafer Format",
      text:
        "210 mm × 182.3 mm (± 0.25 mm) — the 'golden ratio' design that maximizes power output while keeping module dimensions compatible with standard TOPCon modules.",
    },
    {
      title: "N-Type TOPCon Technology",
      text:
        "Low degradation, excellent temperature performance, and high energy yield even under low-light conditions.",
    },
    {
      title: "Half-Cut Cell Design",
      text:
        "132 half-cut bifacial cells per module, enabling higher power ratings and bifacial gain potential of up to 30%.",
    },
    {
      title: "Multi-Busbar (MBB) Design",
      text:
        "Typically 16 busbars for improved current collection and reduced resistive losses.",
    },
    {
      title: "Bifaciality",
      text:
        "Designed for bifacial modules, capturing rear-side irradiance for additional energy yield.",
    },
    {
      title: "Low LID and LeTID",
      text:
        "Minimal light-induced degradation for long-term performance stability.",
    },
  ];

  const whyPoints = [
    {
      icon: "⚡",
      title: "Higher Power Density, Lower BOS Costs",
      text:
        "The G12R rectangular format delivers approximately 5% higher power generation compared to standard TOPCon modules of similar size, reducing Balance of System (BOS) costs and lowering the Levelized Cost of Energy (LCOE).",
    },
    {
      icon: "🏭",
      title: "Backward Integration & Quality Control",
      text:
        "With the upcoming 5 GW cell plant in Gwalior, Gautam Solar will control the entire value chain from cell to module, ensuring consistent quality, faster innovation, and reduced dependence on imports.",
    },
    {
      icon: "🏆",
      title: "Proven Manufacturing Excellence",
      text:
        "Gautam Solar operates state-of-the-art module facilities in Bhiwani (Haryana) and Haridwar (Uttarakhand) with a combined 5 GW capacity, and has been ranked among India's top solar module manufacturers.",
    },
    {
      icon: "✅",
      title: "Certifications & Compliance",
      text:
        "Gautam Solar's G12R modules are ALMM-listed, BIS-approved, and certified to UL, IEC, and EN standards — making them eligible for government projects and export-ready for global markets.",
    },
  ];

  const applications = [
    {
      emoji: "🏜️",
      title: "Utility-Scale Solar Plants",
      text: "High power density reduces land requirement and BOS costs.",
    },
    {
      emoji: "🏢",
      title: "Commercial & Industrial Rooftops",
      text: "Compact size and high output maximize limited roof space.",
    },
    {
      emoji: "🌄",
      title: "Ground-Mounted Projects",
      text: "Bifacial gain and low degradation improve long-term ROI.",
    },
    {
      emoji: "🔋",
      title: "Hybrid & Storage-Integrated Systems",
      text: "Compatible with Gautam Solar's BESS and inverter offerings.",
    },
  ];

  const timeline = [
    {
      year: "2025",
      text: "Module capacity expanded to 5 GW — completed.",
    },
    {
      year: "2026",
      text: "5 GW cell plant commissioning in Gwalior, Madhya Pradesh.",
    },
    {
      year: "By 2030",
      text: "Fully integrated cell + module facility in Narmadapuram.",
    },
  ];

  return (
    <div style={styles.page}>
      {/* HERO */}
      <section style={styles.hero}>
        <div style={styles.heroBadge}>Gautam Solar · 5 GW Cell Platform</div>
        <h1 style={styles.heroTitle}>
          G12R 5 GW Solar Cell
        </h1>
        <p style={styles.heroSubtitle}>
          Powering India's solar future with next-generation G12R N-Type TOPCon
          cell technology — engineered for higher power density, superior
          efficiency, and long-term performance.
        </p>
      </section>

      {/* OVERVIEW */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Overview</h2>
        <div style={styles.sectionTitleUnderline}></div>
        <p style={styles.paragraph}>
          Gautam Solar, one of India's top solar manufacturers, has expanded its
          module production capacity to <strong>5 GW</strong> and is now setting
          up a <strong>5 GW solar cell manufacturing facility</strong> to
          strengthen backward integration and deliver high-performance G12R
          cells to the market. This page outlines everything you need to know
          about the G12R cell platform that powers Gautam Solar's high-wattage
          modules.
        </p>
        <p style={styles.paragraph}>
          Gautam Solar's G12R cell is built on advanced{" "}
          <strong>N-Type TOPCon</strong> technology and uses a{" "}
          <strong>rectangular wafer format</strong> that delivers higher power
          density without increasing module size. The G12R cells are the
          foundation of Gautam Solar's 620–640 Wp G12R TOPCon modules, which
          achieve up to <strong>23.69% module efficiency</strong> and are
          certified by ALMM and BIS.
        </p>
        <p style={styles.paragraph}>
          The company is commissioning a{" "}
          <strong>5 GW solar cell manufacturing plant in Gwalior, Madhya Pradesh</strong>, in
          2026, marking a major step toward deeper vertical integration and
          stronger control over product quality and costs.
        </p>
      </section>

      {/* KEY FEATURES */}
      <section style={styles.sectionAlt}>
        <div style={styles.sectionAltInner}>
          <h2 style={styles.sectionTitle}>Key Features of the G12R Cell</h2>
          <div style={styles.sectionTitleUnderline}></div>
          <div style={styles.featuresGrid}>
            {features.map((f, i) => (
              <div key={i} style={styles.featureCard}>
                <div style={styles.featureTitle}>{f.title}</div>
                <p style={styles.featureText}>{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CELL SPECS */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Technical Specifications (Cell Level)</h2>
        <div style={styles.sectionTitleUnderline}></div>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Parameter</th>
              <th style={styles.th}>Value</th>
            </tr>
          </thead>
          <tbody>
            {cellSpecs.map((row, i) => (
              <tr key={i}>
                <td style={i % 2 === 0 ? styles.td : styles.tdAlt}>{row.label}</td>
                <td style={i % 2 === 0 ? styles.td : styles.tdAlt}>{row.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {/* MODULE SPECS */}
      <section style={styles.sectionAlt}>
        <div style={styles.sectionAltInner}>
          <h2 style={styles.sectionTitle}>
            Module-Level Performance (Powered by G12R Cells)
          </h2>
          <div style={styles.sectionTitleUnderline}></div>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Parameter</th>
                <th style={styles.th}>Value</th>
              </tr>
            </thead>
            <tbody>
              {moduleSpecs.map((row, i) => (
                <tr key={i}>
                  <td style={i % 2 === 0 ? styles.td : styles.tdAlt}>{row.label}</td>
                  <td style={i % 2 === 0 ? styles.td : styles.tdAlt}>{row.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* WHY GAUTAM SOLAR */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Why G12R Cells from Gautam Solar?</h2>
        <div style={styles.sectionTitleUnderline}></div>
        <div style={styles.whyGrid}>
          {whyPoints.map((w, i) => (
            <div key={i} style={styles.whyCard}>
              <div style={styles.whyIcon}>{w.icon}</div>
              <div style={styles.whyTitle}>{w.title}</div>
              <p style={styles.whyText}>{w.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* APPLICATIONS */}
      <section style={styles.sectionAlt}>
        <div style={styles.sectionAltInner}>
          <h2 style={styles.sectionTitle}>Applications</h2>
          <div style={styles.sectionTitleUnderline}></div>
          <div style={styles.appGrid}>
            {applications.map((a, i) => (
              <div key={i} style={styles.appCard}>
                <div style={styles.appEmoji}>{a.emoji}</div>
                <div style={styles.appTitle}>{a.title}</div>
                <p style={styles.appText}>{a.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TIMELINE */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Manufacturing Roadmap</h2>
        <div style={styles.sectionTitleUnderline}></div>
        <div style={styles.timeline}>
          {timeline.map((t, i) => (
            <div key={i} style={styles.timelineItem}>
              <div style={styles.timelineDot}></div>
              <div style={styles.timelineYear}>{t.year}</div>
              <p style={styles.timelineText}>{t.text}</p>
            </div>
          ))}
        </div>
        <p style={{ ...styles.paragraph, marginTop: "20px" }}>
          Gautam Solar's expansion is aligned with India's{" "}
          <strong>Atmanirbhar Bharat</strong> and{" "}
          <strong>National Solar Mission</strong> goals, supporting domestic
          manufacturing and reducing import dependence.
        </p>
      </section>

      {/* CTA */}
      <section style={styles.cta}>
        <h2 style={styles.ctaTitle}>Get in Touch</h2>
        <p style={styles.ctaText}>
          For product datasheets, pricing, or partnership inquiries regarding
          the G12R 5 GW solar cell, please contact Gautam Solar's sales team or
          visit the official website.
        </p>
        <button style={styles.ctaButton}>Contact Sales Team →</button>
      </section>

      {/* FOOTNOTE */}
      <p style={styles.footnote}>
        All specifications are indicative and subject to final product
        datasheets. Please refer to official Gautam Solar documentation for the
        most current information.
      </p>
    </div>
  );
};




const CombinedInverterBessSection = () => {
  const navigate = useNavigate();
  const theme = '#a20000'; // Exact 6-digit hex code
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  /* ============================================================
     SHARED STYLES
  ============================================================ */

  const sectionBaseStyle = {
    padding: isMobile ? '60px 16px' : '100px 24px',
    fontFamily: '"Inter", "Segoe UI", Roboto, Arial, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  };

  // --- Centered Header ---
  const headerWrapperStyle = {
    textAlign: 'center',
    marginBottom: '48px',
    maxWidth: '900px'
  };

  const mainHeadingStyle = {
    fontSize: isMobile ? '32px' : '46px',
    fontWeight: '600',
    color: '#1a1a1a',
    margin: '0 0 16px 0',
    letterSpacing: '-0.02em',
    textTransform: 'uppercase'
  };

  const subTitleStyle = {
    fontSize: isMobile ? '15px' : '17px',
    color: '#666',
    lineHeight: '1.6',
    margin: 0
  };

  // --- Card Container (background configurable per section) ---
  const getCardContainerStyle = (backgroundColor = '#ffffff') => ({
    width: '100%',
    maxWidth: '1000px',
    backgroundColor,
    borderRadius: '16px',
    border: '1px solid #eaeaea',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.04)',
    padding: isMobile ? '32px 20px' : '56px 48px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  });

  // --- Badge ---
  const badgeStyle = {
    backgroundColor: theme,
    color: '#ffffff',
    padding: '8px 20px',
    borderRadius: '100px',
    fontSize: '12px',
    fontWeight: '700',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    marginBottom: '32px',
    display: 'inline-block'
  };

  // --- Upcoming Tag ---
  const upcomingTagStyle = {
    backgroundColor: 'rgba(162, 0, 0, 0.08)',
    color: theme,
    padding: '6px 14px',
    borderRadius: '100px',
    fontSize: '12px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '12px',
    display: 'inline-block'
  };

  // --- Product Block ---
  const productBlockStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%'
  };

  const productTitleStyle = {
    fontSize: isMobile ? '24px' : '28px',
    fontWeight: '700',
    color: '#1a1a1a',
    marginBottom: '24px',
    marginTop: 0
  };

  const imageWrapperStyle = {
    width: '100%',
    maxWidth: '600px',
    aspectRatio: '16/9',
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #f0f0f0',
    marginBottom: '32px',
    overflow: 'hidden'
  };

  // --- Specs Grid ---
  const specsGridStyle = {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
    gap: '16px 32px',
    width: '100%',
    maxWidth: '800px',
    textAlign: 'left',
    marginBottom: '40px'
  };

  const specItemStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    fontSize: '15px',
    lineHeight: '1.6',
    color: '#444'
  };

  const bulletStyle = {
    color: theme,
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '1.4'
  };

  const buttonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    padding: '16px 40px',
    backgroundColor: theme,
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 14px rgba(162, 0, 0, 0.2)',
    width: isMobile ? '100%' : 'auto'
  };

  /* ============================================================
     HANDLERS
  ============================================================ */

  const handleInverterClick = () => navigate('/inverter-ongrid');
  const handleBessClick = () => navigate('/bess');

  const handleHover = (e, isHovering) => {
    if (isMobile) return;
    if (isHovering) {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.boxShadow = '0 8px 24px rgba(162, 0, 0, 0.35)';
    } else {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 4px 14px rgba(162, 0, 0, 0.2)';
    }
  };

  /* ============================================================
     RENDER
  ============================================================ */

  return (
    <div>
      {/* ============================================================
          SECTION 1 — SOLAR INVERTERS
      ============================================================ */}
      <section
        id="inverters"
        style={{ ...sectionBaseStyle, backgroundColor: '#fafafa' }}
      >
        {/* Header */}
        <div style={headerWrapperStyle}>
          <h2 style={mainHeadingStyle}>
            SOLAR <span style={{ color: theme }}>INVERTERS</span>
          </h2>
          <p style={subTitleStyle}>
            Reliable, high-efficiency solar inverters engineered for residential
            and commercial rooftop installations.
          </p>
        </div>

        {/* White Card */}
        <div style={getCardContainerStyle('#ffffff')}>
          <span style={badgeStyle}>PRODUCT OVERVIEW</span>

          <div style={productBlockStyle}>
            <h3 style={productTitleStyle}>Grid-Tied Solar Inverters</h3>

            <div style={imageWrapperStyle}>
              {/* REPLACE THIS WITH YOUR ACTUAL IMAGE */}
              <img
                // src="inverterSection.webp"
                src="3KW-Inverter.webp"
                alt="Gautam Solar Inverter"
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            </div>

            <div style={specsGridStyle}>
              <div style={specItemStyle}>
                <span style={bulletStyle}>→</span>
                <span>Available in 3 kW and 5 kW models with MPPT technology.</span>
              </div>
              <div style={specItemStyle}>
                <span style={bulletStyle}>→</span>
                <span>Maximum efficiency of up to 97.5% and MPPT efficiency above 99%.</span>
              </div>
              <div style={specItemStyle}>
                <span style={bulletStyle}>→</span>
                <span>Wi-Fi and RS485 communication for compatible monitoring systems.</span>
              </div>
              <div style={specItemStyle}>
                <span style={bulletStyle}>→</span>
                <span>IP65 enclosure protection against dust and water ingress.</span>
              </div>
            </div>

            <button
              style={buttonStyle}
              onClick={handleInverterClick}
              onMouseEnter={(e) => handleHover(e, true)}
              onMouseLeave={(e) => handleHover(e, false)}
            >
              Explore Inverters
              <span style={{ fontSize: '18px', lineHeight: 1 }}>→</span>
            </button>
          </div>
        </div>
      </section>

      {/* ============================================================
          SECTION 2 — BATTERY ENERGY STORAGE SYSTEMS (BESS)
      ============================================================ */}
      <section
        id="bess"
        style={{ ...sectionBaseStyle, backgroundColor: '#ffffff' }}
      >
        {/* Header */}
        <div style={headerWrapperStyle}>
          <h2 style={mainHeadingStyle}>
            BATTERY ENERGY<span style={{ color: theme }}> STORAGE SYSTEM - (BESS)</span>
          </h2>
          <p style={subTitleStyle}>
            Advanced, scalable battery energy storage systems built for
            commercial, industrial and utility-scale applications.
          </p>
        </div>

        {/* Card */}
        <div style={getCardContainerStyle('#fafafa')}>
          {/* <span style={upcomingTagStyle}>Upcoming in 2027</span> */}

          <div style={{ ...productBlockStyle, marginTop: '16px' }}>
            <h3 style={productTitleStyle}>Battery Energy Storage Systems</h3>

            <div style={imageWrapperStyle}>
              {/* REPLACE THIS WITH YOUR ACTUAL IMAGE */}
              <img
                // src="bessSection-1.webp"
                // src="BESS-5gwh.webp"
                src="5mwh&125kwhBESS.webp"
                alt="Gautam Solar BESS"
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            </div>

            <div style={specsGridStyle}>
              <div style={specItemStyle}>
                <span style={bulletStyle}>→</span>
                <span>
                  Modular architecture designed to scale with changing project
                  requirements.
                </span>
              </div>
              <div style={specItemStyle}>
                <span style={bulletStyle}>→</span>
                <span>
                  Advanced LFP chemistry with multi-layer protection and
                  real-time monitoring.
                </span>
              </div>
              <div style={specItemStyle}>
                <span style={bulletStyle}>→</span>
                <span>
                  C&amp;I solution: 125 kW / 261.2 kWh capacity, 90% DoD, IP55
                  rating.
                </span>
              </div>
              <div style={specItemStyle}>
                <span style={bulletStyle}>→</span>
                <span>
                  Utility-scale solution: GS-5000-LC model, 5,015 kWh capacity,
                  8,000 cycles.
                </span>
              </div>
            </div>

            <button
              style={buttonStyle}
              onClick={handleBessClick}
              onMouseEnter={(e) => handleHover(e, true)}
              onMouseLeave={(e) => handleHover(e, false)}
            >
              Explore BESS
              <span style={{ fontSize: '18px', lineHeight: 1 }}>→</span>
            </button>
          </div>
        </div>
      <Container className="text-center mt-5" data-aos="fade-right">
        <img
          src={bessBanner}
          alt="Solar modules showcase"
          className="img-fluid bottom-slider"
          loading="lazy"
          width={1260}
          height={800}
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </Container>
      </section>
    </div>
  );
};

